import React from "react";
import "./style.scss";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { NavLink } from "react-router-dom";
import { ReactComponent as Hamburger } from "../../../assets/icons/hamburger.svg";

const CustomNav = () => {
  return (
    <Navbar variant="dark" expand="lg" className="custom-nav">
      <Container>
        <Navbar.Toggle aria-controls="list">
          <Hamburger size="24" />
        </Navbar.Toggle>
        <Navbar.Brand>
          <img alt="brand" />
        </Navbar.Brand>
        <Navbar.Collapse id="list">
          <Nav className="ms-auto align-items-center">
            <li className="nav-item">
              <NavLink to="/">Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="#/">About</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="#/">Jobs</NavLink>
            </li>
            <li className="nav-item">
              <button>Get My Free Offer</button>
            </li>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNav;
